import { render, staticRenderFns } from "./VocabCardModal.vue?vue&type=template&id=53865f7a&scoped=true&"
import script from "./VocabCardModal.vue?vue&type=script&lang=js&"
export * from "./VocabCardModal.vue?vue&type=script&lang=js&"
import style0 from "./VocabCardModal.vue?vue&type=style&index=0&id=53865f7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53865f7a",
  null
  
)

export default component.exports